import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  table: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777'
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    }
  }
}));
